<app-tab>
  <dx-text-box
    stylingMode="filled"
    (onValueChanged)="searchGrid($event)"
    placeholder="Recherche..."
  >
    <dxi-button
      name="icon"
      location="before"
      [options]="{
        type: 'text',
        icon: 'search',
        disabled: true,
        elementAttr: { class: 'map-sidebar-search-panel-btn' }
      }"
    ></dxi-button>
    <dxi-button
      name="filter"
      location="after"
      [options]="{ type: 'text', icon: 'filter', onClick: filterClick }"
    ></dxi-button>
  </dx-text-box>

  <dx-toolbar class="map-sidebar-toolbar">
    <dxi-item
      location="after"
      widget="dxButton"
      locateInMenu="auto"
      [options]="{
        icon: groupToggleIcon,
        hint: 'Afficher/Cacher',
        onClick: groupsToggle
      }"
    ></dxi-item>
    <dxi-item
      location="after"
      widget="dxButton"
      locateInMenu="auto"
      [options]="{ icon: 'refresh', hint: 'Recharger', onClick: refreshGrid }"
    ></dxi-item>
    <dxi-item
      location="after"
      widget="dxButton"
      locateInMenu="auto"
      [options]="{ icon: 'search', hint: 'Recherche', onClick: toggleSearch }"
    >
    </dxi-item>
  </dx-toolbar>

  <dx-data-grid
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    [errorRowEnabled]="false"
    [showColumnHeaders]="false"
    [hoverStateEnabled]="true"
    [activeStateEnabled]="true"
    [repaintChangesOnly]="true"
    (onRowExpanded)="onRowExpanded($event)"
    (onRowCollapsed)="onRowCollapsed($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onRowClick)="onRowClick($event)"
    (onContentReady)="onGridContentReady($event)"
    [columnAutoWidth]="true"
  >
    <dxo-grouping expandMode="rowClick" [autoExpandAll]="true"></dxo-grouping>

    <dxi-column
      dataField="name"
      dataType="string"
      alignment="left"
      cellTemplate="cellTemplate"
    >
      <div *dxTemplate="let cell of 'cellTemplate'">
        <div #item class="flex flex-row">
          <div
            style="height: 50px; width: 50px"
            class="text-center self-center mr-2 relative"
          >
            <lib-field-svg
              [width]="50"
              [height]="50"
              [field]="cell.data"
              [strokeWidth]="1"
            ></lib-field-svg>
          </div>
          <div class="mr-2">
            <div class="text-gray-700 text-sm font-normal uppercase mb-3">
              {{ cell.data.name }}
            </div>

            <div class="flex items-center text-xs text-gray-500">
              <p class="mr-1" title="Culture">
                <i class="dx-icon-ld-crop"></i>&nbsp;
                <span
                  (click)="showCropsGrid(cell.data)"
                  [title]="cell.data?.crop?.path_str || 'Non Disponible'"
                  class="border-b border-dotted border-gray-700 mb-1 cursor-pointer"
                  >{{ cell.data?.crop?.name || "NA" }}</span
                >
              </p>
              <p class="px-1">•</p>
              <p class="mr-1" title="Superficie Cultivée">
                <i class="dx-icon-ld-area"></i>
                {{ cell.field_crop_cadastral_area || 0 }} ({{
                  ((cell.data?.field_crop_percent || 0) * 100).toFixed(1)
                }}%)
              </p>
            </div>
          </div>
        </div>
        <dx-context-menu
          [dataSource]="editMenu"
          [target]="item"
          [width]="100"
          (onItemClick)="editMenuClick($event, cell.data)"
        >
          <div
            class="text-gray-700 text-sm"
            *dxTemplate="let m of 'item'; let i = index"
          >
            <span class="text-base dx-icon-{{ m.icon }}"></span>
            <span class="ml-2">{{ m.name }}</span>
          </div>
        </dx-context-menu>
      </div>
    </dxi-column>

    <dxi-column
      dataType="string"
      alignment="left"
      name="domain_name"
      dataField="domain_name"
      groupCellTemplate="domainGroupTemplate"
      [formItem]="{ visible: false }"
      [visible]="false"
    >
      <app-map-sidebar-group-header
        *dxTemplate="let group of 'domainGroupTemplate'"
        [group]="group"
      ></app-map-sidebar-group-header>
    </dxi-column>

    <dxi-column
      dataType="string"
      alignment="left"
      name="business_unit_name"
      dataField="business_unit_name"
      groupCellTemplate="buGroupTemplate"
      [formItem]="{ visible: false }"
      [visible]="false"
    >
      <app-map-sidebar-group-header
        *dxTemplate="let group of 'buGroupTemplate'"
        [group]="group"
      ></app-map-sidebar-group-header>
    </dxi-column>

    <dxi-column caption="Culture" [visible]="false" dataField="crop.name">
    </dxi-column>

    <dxo-summary>
      <dxi-group-item column="name" summaryType="count"> </dxi-group-item>
    </dxo-summary>
  </dx-data-grid>
</app-tab>

<app-field-crops-popup></app-field-crops-popup>
